<mat-card>
  <mat-card-header>
    <div class="flex" style="width: 100%;justify-content: center;">
      <span style="font-size:1rem !important;"> <strong>แจ้งปิดปรับปรุงระบบ</strong></span>
    </div>
  </mat-card-header>
  <mat-dialog-content>
    <div class="pl-12 pr-12 pt-4 pb-4 flex flex-col gap-4">
      <div class="flex" style="flex-direction: column;">
        <div style="text-align: center;">
          <p>หอการค้าไทย ขอปิดระบบ CO</p>
        </div>
        <div style="text-align: center;">
          <p><span style="color: red; font-weight: bold;">ระหว่างเวลา
              23.30 น. - 00.30 น.</span></p>
        </div>
        <div style="text-align: center;">
          <p>เพื่อปรับปรุงข้อมูลประจำวัน
          </p>
        </div>
        <ng-container *ngIf="form.allowClose">
          <div class="flex justify-center gap-2.5" style="gap: 10px;">
            <button mat-raised-button [mat-dialog-close]>ปิด</button>
          </div>
        </ng-container>
      </div>
    </div>
  </mat-dialog-content>
</mat-card>